// AuthService — PUBLIC auth endpoints (login + forgotten-password flow). These need NO token:
// the interceptor in configureApi only attaches Authorization when a token exists in localStorage,
// and these are called from the unauthenticated login/forgotten-password screens. Migrated to the
// OpenAPI-generated client; each function keeps its old return shape (callers read `res.data.body`
// for the login JWT, and rely on rejection carrying `e.response.data.errorCode` on failure), so the
// adapter returns `{data}` on success and re-throws an axios-shaped `{response:{data,status}}` on error.

import {
  authControllerGenerateForgottenPasswordToken,
  authControllerValidateToken,
  authControllerResetPassword,
  authControllerAuthenticateUser,
} from '../api/generated';

// Preserve the legacy axios rejection shape so call sites reading `e.response.data.errorCode` keep working.
const throwLikeAxios = (error, response) => {
  throw {response: {data: error, status: response?.status}};
};

export const sendToken = async (email) => {
  const {data, error, response} = await authControllerGenerateForgottenPasswordToken({
    path: {email},
  });
  if (error) throwLikeAxios(error, response);
  return {data};
};

export const verifyToken = async (token, email) => {
  const {data, error, response} = await authControllerValidateToken({
    body: {email, token},
  });
  if (error) throwLikeAxios(error, response);
  return {data};
};

export const resetPasswordWithToken = async (token, email, password) => {
  const {data, error, response} = await authControllerResetPassword({
    body: {email, token, password},
  });
  if (error) throwLikeAxios(error, response);
  return {data};
};

export async function userLogin(username, password) {
  const {data, error, response} = await authControllerAuthenticateUser({
    body: {username, password},
  });
  if (error) throwLikeAxios(error, response);
  // Old caller reads res.data.body (the JWT string from the HttpResponse<String> envelope).
  return {data};
}
